import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-group" }

import { inject, onBeforeMount, ref } from 'vue'
import { userProfilesApi } from '@/di/api'
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";
import FormKitSubmitButtonContent from "@/components/app/FormKit/FormKitSubmitButtonContent.vue";
import { notifyInjectionKey } from "@/keys";

interface Model {
  password: string,
  password_confirm: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordForm',
  setup(__props) {

const notify = inject(notifyInjectionKey)

const showForm = ref<boolean>(false)

const model = ref<Model>({ password: '', password_confirm: '' })

const lock = ref<{ formSubmitting: boolean }>({ formSubmitting: false })

const defaultModel = (): Model => ({ password: '', password_confirm: '' })

function handleResetForm (): void {
  model.value = defaultModel()
  showForm.value = false
}

function handleShowForm (): void {
  showForm.value = true
}

async function handleSubmitForm (): Promise<void> {
  lock.value.formSubmitting = true

  await userProfilesApi.changePassword(model.value.password, model.value.password_confirm)

  lock.value.formSubmitting = false

  handleResetForm()

  notify?.({ text: 'Password changed' })
}

onBeforeMount((): void => {
  handleResetForm()
})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppComponentHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Change password")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (!showForm.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: handleShowForm
          }, " Change password "))
        : _createCommentVNode("", true),
      (showForm.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-warning btn-sm mb-3",
            onClick: handleResetForm
          }, " Cancel "))
        : _createCommentVNode("", true)
    ]),
    (showForm.value)
      ? (_openBlock(), _createBlock(_component_FormKit, {
          key: 0,
          modelValue: model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          type: "form",
          actions: false,
          onSubmit: handleSubmitForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              name: "email",
              type: "text",
              autocomplete: "email username",
              "outer-class": "d-none"
            }),
            _createVNode(_component_FormKit, {
              name: "password",
              type: "password",
              autocomplete: "new-password",
              label: "Password",
              validation: "required",
              "outer-class": "mb-3"
            }),
            _createVNode(_component_FormKit, {
              name: "password_confirm",
              type: "password",
              autocomplete: "new-password",
              label: "Repeat Password",
              validation: "required|confirm",
              "validation-name": "Password confirmation",
              "outer-class": "mb-3"
            }),
            _createVNode(_component_FormKit, {
              type: "submit",
              "input-class": "btn btn-primary btn-sm",
              disabled: lock.value.formSubmitting
            }, {
              default: _withCtx(() => [
                _createVNode(FormKitSubmitButtonContent, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Change")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})